import React, { FC, HTMLAttributes, ReactNode } from 'react';
import { Button as Btn, ButtonProps } from '@chakra-ui/core';

export interface Props extends HTMLAttributes<ButtonProps> {
  children?: ReactNode;
  danger?: boolean;
  isDisabled?: boolean;
}

export const Button: FC<Props> = ({ children, danger = false, ...props }) => {
  return (
    <Btn
      backgroundColor={danger ? 'red.500' : 'primary.500'}
      borderColor="transparent"
      fontWeight="500"
      color="white"
      fontFamily="body"
      fontSize="11px"
      height="32px"
      width="100%"
      variantColor={danger ? 'red' : 'primary'}
      _disabled={{
        backgroundColor: 'gray.500',
        color: 'gray.50',
      }}
      {...props}
    >
      {children}
    </Btn>
  );
};
